import assign from 'lodash/assign';
import * as APIS from '../../constants/api';

export const salesChannelManagement =
  (action, payload) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.SALES_CHANNEL_MANAGEMENT, assign({ action }, payload))
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const e = 5;
